import { useState } from 'react';
import { useTablePreferences } from '../container';

/**
 * A panel that folds, and stays as it was last left on this device. Request of
 * 4 October 2026, section 4, for the current task card.
 *
 * Null until the person has folded or opened it once, so the screen can pick a
 * sensible first state from what it knows; from then on their choice holds.
 */
export function useFolded(panelKey: string): [boolean | null, (folded: boolean) => void] {
  const preferences = useTablePreferences();
  const [folded, setFolded] = useState(() => preferences.folded(panelKey));
  return [
    folded,
    (next: boolean) => {
      setFolded(next);
      preferences.rememberFolded(panelKey, next);
    },
  ];
}
